// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"b4fe5600","425":"a3345f5f","510":"82e387a8","532":"414d80e7","633":"abb8827a","634":"72bf9511","922":"23994b14","937":"7baad518","972":"2db9c04d"}[chunkId] + ".chunk.js";
};